import twttr from 'twitter-text';

import {ContactInformationContact} from '../../srcCommon/inboxes/contactDetails/contactDetailsHelpers';
import {VisualRecipientModel} from '../models/api/visualRecipientModel';

/** Check if the provided text is a valid tweet. */
export function isTweetTextValid(text: string) {
  return twttr.parseTweet(text).valid;
}

/** Build the text of a Twitter reply with the provided recipients. */
export function buildTwitterReplyText(recipients: ReadonlyArray<VisualRecipientModel>) {
  const mentions = recipients.map((v) => v.contact.handle).join(' ');
  return `${mentions} `;
}

export function buildTwitterProfileUrl(contact: ContactInformationContact) {
  const {handle} = contact;
  if (handle.startsWith('@')) {
    const trimmedHandle = handle.substring(1);
    return `https://twitter.com/${trimmedHandle}`;
  }

  return `https://twitter.com/${handle}`;
}

/**
 * Validates a passed in value to see if it is a valid twitter handle.
 * https://help.twitter.com/en/managing-your-account/twitter-username-rules
 *
 * Conditions:
 * - Alphanumeric and underscores only.
 * - Username cannot be longer than 15 characters or shorter than 4 characters
 */
const twitterHandleRegExp = new RegExp(/^@?(\w{4,15})$/);
export function isValidTwitterHandle(address: string) {
  return twitterHandleRegExp.test(address);
}
